import Vue from 'vue'
import Vuex from 'vuex'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'center'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        center: {
          eduGroupCode: '',
          eduGroupName: '',
          coGroupCode: '',
          coGroupName: '',
          eduGroupSupportLangList: [],
          eduGroupBaseDateFormatCode: '',
          eduGroupBaseLangCode: '',
          eduGroupBaseTimeZoneCode: ''
        }
      },
      getters: {
        getState: state => {
          return state.center
        },
        getEduGroupCode: state => {
          return state.center.eduGroupCode
        },
        getEduGroupName: state => {
          return state.center.eduGroupName
        },
        getCoGroupCode: state => {
          return state.center.coGroupCode
        },
        getCoGroupName: state => {
          return state.center.coGroupName
        },
        getEduGroupSupportLangList: state => {
          return state.center.eduGroupSupportLangList
        },
        getEduGroupBaseDateFormatCode: state => {
          return state.center.eduGroupBaseDateFormatCode
        },
        getEduGroupBaseLangCode: state => {
          return state.center.eduGroupBaseLangCode
        },
        getEduGroupBaseTimeZoneCode: state => {
          return state.center.eduGroupBaseTimeZoneCode
        }
      },
      mutations: {
        // 연수원 정보 저장
        REGISTER (state, center) {
          state.center = center
        },
        // 연수원 정보 초기화
        DELETE (state) {
          state.center = {
            eduGroupCode: '',
            eduGroupName: '',
            coGroupCode: '',
            coGroupName: '',
            eduGroupSupportLangList: [],
            eduGroupBaseDateFormatCode: '',
            eduGroupBaseLangCode: '',
            eduGroupBaseTimeZoneCode: ''
          }
        }
      },
      actions: {
        REGISTER ({commit}, {center}) {
          return commit('REGISTER', center)
        },
        DELETE ({commit}) {
          commit('DELETE')
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/center.js